import { createFileRoute } from '@tanstack/react-router';
import { useFlagsStatus } from '@unleash/proxy-client-react';

import ExploreEventsListing from '@/components/_events/ExploreEventsListing.tsx';
import ExplorePage from '@/components/_explore/ExplorePage.tsx';
import { ExploreLayout } from '@/components/layouts/index.tsx';
import PageLoading from '@/components/loading/PageLoading.tsx';
import PageDisabled from '@/components/PageDisabled.tsx';
import useFlag from '@/lib/hooks/useFlag.ts';

// biome-ignore lint/style/useComponentExportOnlyModules: tanstack route
const Games = () => {
  const featuresReady = useFlagsStatus().flagsReady;
  const enableGames = useFlag('explore.games');

  if (!featuresReady) {
    return <PageLoading />;
  }
  if (!enableGames) {
    return <PageDisabled absolutelyCentered />;
  }

  return (
    <ExplorePage isSubPage title="explore:games">
      <ExploreEventsListing types={['gamelobby']} showQuestBadge />
    </ExplorePage>
  );
};

export const Route = createFileRoute('/explore/games')({
  component: () => (
    <ExploreLayout title="explore:games">
      <Games />
    </ExploreLayout>
  ),
});
